<div class="cursor-pointer hover:opacity-70 transition-all w-6 h-6" [class.pointer-events-none]="disabled" [class.opacity-30]="disabled">
  <img [ngSrc]="icon" [width]="24" [height]="24" [style.height.px]="24" />
</div>
